export default "__VITE_ASSET__C_0xJA40__"